import { ref } from 'vue'

const isLoading = ref(false)

export const usePageLoader = () => {
  const show = () => {
    isLoading.value = true
  }

  const hide = () => {
    isLoading.value = false
  }

  return {
    isLoading,
    show,
    hide,
  }
}
